export var isAllDayEvent = function isAllDayEvent(calendarItem) {
  return calendarItem.type === 'event' && !!calendarItem.pin && !!calendarItem.pin.date;
};
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/event.js
// module id = 250
// module chunks = 0